export default "__VITE_ASSET__BVlBY25E__"